import {
    HttpErrorResponse,
    HttpInterceptorFn,
    HttpResponse,
} from "@angular/common/http";
import { Game } from "@Front-end/seed/models/game";
import { SearchResult } from "@Front-end/seed/models/search";
import {
    catchError,
    map,
    Observable,
    throwError,
} from "rxjs";
import { tournamentGameId } from "../../constants/tourmament-game.constants";

export const tournamentGamesInterceptor: HttpInterceptorFn = (req, next) => {
    const gameUrl: string = "game/list";
    const searchUrl: string = "/search";
    const gameId: number = tournamentGameId;

    return next(req).pipe(
        map((event) => {
            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event.body as { result: unknown })?.result
                && req.url.includes(gameUrl)
            ) {
                // @ts-ignore
                const updatedGames: Game[] = (<Game[]> event.body.result)
                    .filter((item: Game) => item.game_id !== gameId);
                // @ts-ignore
                event = event.clone({ body: { ...event.body, result: updatedGames } });
            }

            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event.body as { result: unknown })?.result
                && req.url.includes(searchUrl)
            ) {
                // @ts-ignore
                const updatedGames: Game[] = (<Game[]> event.body.result.games.result)
                    .filter((item: Game) => item.game_id !== gameId);
                const updatedResult: SearchResult = {
                    // @ts-ignore
                    ...event.body.result,
                    games: {
                        // @ts-ignore
                        ...event.body.result.games,
                        result: updatedGames,
                    },
                };
                event = event.clone({
                    // @ts-ignore
                    body: { ...event.body, result: updatedResult },
                });
            }

            return event;
        }),
        catchError((error: HttpErrorResponse): Observable<never> => throwError(() => error)),
    );
};
